import { combineReducers } from "@reduxjs/toolkit";
import { apiSlice } from "../services/apiSlice";
import authReducer from "./authSlice";
import categoryFilterReducer from "./categorySlice";
import orderFilterReducer from "./orderFilterSlice";
import cancellationFilterReducer from "./cancellationFilterSlice";
import refundFilterReducer from "./refundFilterSlice";
import modalReducer from "./modalSlice";
import productListReducer from "./productListFilterSlice"

const appReducer = combineReducers({
  auth: authReducer,
  modal: modalReducer,
  categoryFilter: categoryFilterReducer,
  refundFilter: refundFilterReducer,
  cancellationFilter: cancellationFilterReducer,

  orderFilter: orderFilterReducer,
  productListFilter: productListReducer,
  [apiSlice.reducerPath]: apiSlice.reducer,
});

export default appReducer;
